<template>
  <div>
    <WebHeaderView />
    <div class="register-box">
      <div class="title">登录商户</div>
      <van-form :validate-first="true" @submit="onSubmit" :label-width="50">
        <div class="item">
          <van-field
            v-model="frm.account"
            label="用户名"
            placeholder="请填写用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
            style="border: none"
          />
        </div>
        <div class="item">
          <van-field
            v-model="frm.password"
            type="password"
            label="密码"
            placeholder="请填写密码"
            :rules="[{ required: true, message: '请填写密码' }]"
            style="border: none"
          />
        </div>
        <div style="margin: 36px 0 0">
          <van-button
            block
            native-type="submit"
            :loading="posting"
            loading-text="登录中..."
            style="background-color: #141423; color: #fff; border-radius: 8px"
            >登录</van-button
          >
        </div>
      </van-form>
      <div style="font-size: 14px; text-align: right; margin-top: 30px">
        <router-link class="link-btn" :to="'/register'" style="color: #000">
          还没有账号，去成为商家</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import { setToken, getToken } from '@/utils/cookies'
export default {
  name: 'LoginView',
  components: { WebHeaderView },
  data () {
    return {
      frm: {
        account: null,
        password: null
      },
      posting: false
    }
  },
  mounted () {
    if (getToken()) {
      this.$router.push({ name: 'mine' })
      return
    }
  },
  methods: {
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'login',
        data: this.frm
      })
        .then(res => {
          console.log(res.data.token)
          this.posting = false
          setToken(res.data.token)
          location.reload()
        })
        .catch(() => {
          this.posting = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.register-box {
  margin: 100px 20px;
  background: #fff;
  border-radius: 10px;
  padding: 30px 10px;
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 38px;
    height: 38px;
  }
  .item {
    border-bottom: 1px solid #646566;
    margin: 15px 0;
    padding: 3px;
  }
}
</style>
